// "Bu firma mı?" onayı: aynı adlı kayıtlı firma/şubeler gösterilir; kullanıcı seçer veya farklı firma olduğunu belirtir
import { Building2 } from 'lucide-react';
import { Button } from '../../ui/button';

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString('tr-TR') : '-');

export const firmLabel = (f) => (f.branch_name ? `${f.name} - ${f.branch_name}` : f.name);

export const BehalfMatchPanel = ({ candidates, differentMode, onPick, onDifferent, onCancel, testPrefix }) => (
  <div className="space-y-2 rounded-md border-2 border-amber-300 bg-amber-50 p-3 text-sm" data-testid={`${testPrefix}-match`}>
    <p className="font-medium text-amber-900">Bu adla kayıtlı firma var. Bu firma mı?</p>
    <div className="space-y-1.5">
      {candidates.map(f => (
        <div key={f.id} className="flex flex-wrap items-center justify-between gap-2 rounded border border-amber-200 bg-white px-2.5 py-1.5" data-testid={`${testPrefix}-match-item-${f.id}`}>
          <div className="text-xs text-slate-700">
            <div className="flex items-center gap-1 font-semibold text-slate-900"><Building2 className="h-3 w-3" />{f.name}</div>
            <div>Vergi No: <b>{f.tax_key || 'Girilmemiş'}</b> · Şube: <b>{f.branch_name || 'Belirtilmemiş'}</b> · Kayıt: {fmtDate(f.created_at)}</div>
          </div>
          <Button type="button" size="sm" variant="outline" onClick={() => onPick(f)} data-testid={`${testPrefix}-match-yes-${f.id}`}>Evet, bu firma</Button>
        </div>
      ))}
    </div>
    {differentMode ? (
      <p className="text-xs text-amber-900" data-testid={`${testPrefix}-different-hint`}>
        Farklı firma/şube olduğunu doğrulamak için yukarıya <b>vergi numarası</b> veya <b>şube adı/kodu</b> girip "Yeni firma olarak kaydet"e basın. Aynı vergi numaralı şubeler şube bilgisiyle ayrılır.
      </p>
    ) : (
      <div className="flex gap-3">
        <button type="button" onClick={onDifferent} className="text-xs text-amber-800 underline" data-testid={`${testPrefix}-match-no`}>Hayır, farklı bir firma / şube</button>
        <button type="button" onClick={onCancel} className="text-xs text-slate-500 underline" data-testid={`${testPrefix}-match-cancel`}>Vazgeç</button>
      </div>
    )}
  </div>
);
